import { useEffect } from "react";
import { createFluidState, trackPointer, renderFrame } from "../lib/fluidParticles";

export function useFluidCanvas(canvasRef) {
  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas?.getContext("2d");
    if (!ctx) return undefined;
    const state = createFluidState();
    let animId = null;

    const resize = () => {
      const dpr = Math.min(window.devicePixelRatio || 1, 2);
      canvas.width = window.innerWidth * dpr;
      canvas.height = window.innerHeight * dpr;
      ctx.scale(dpr, dpr);
    };
    const onMove = (e) => trackPointer(state, e.clientX, e.clientY);
    const onTouch = (e) => { if (e.touches[0]) trackPointer(state, e.touches[0].clientX, e.touches[0].clientY); };
    const loop = () => { renderFrame(ctx, state); animId = requestAnimationFrame(loop); };

    resize();
    window.addEventListener("mousemove", onMove);
    window.addEventListener("touchmove", onTouch, { passive: true });
    window.addEventListener("resize", resize);
    animId = requestAnimationFrame(loop);

    return () => {
      window.removeEventListener("mousemove", onMove);
      window.removeEventListener("touchmove", onTouch);
      window.removeEventListener("resize", resize);
      if (animId) cancelAnimationFrame(animId);
    };
  }, [canvasRef]);
}
